module.exports = __webpack_public_path__ + "static/media/result.e78a007c.svg";